module.exports = __webpack_public_path__ + "images/fox_smallbcd170431a763f33abb3e11a2130514b.png";